module.exports = {"140425100":"青羊镇","140425101":"龙溪镇","140425102":"石城镇","140425103":"苗庄镇","140425104":"玉峡关镇","140425200":"西沟乡","140425201":"东寺头乡","140425202":"虹梯关乡","140425203":"阳高乡","140425204":"北耽车乡","140425206":"北社乡","140425400":"平顺经济技术开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/140425.json
// module id = 386
// module chunks = 0